import axios from 'axios';
import Locale from 'locale-codes';

// Need to import this dynamically otherwise it becomes a circular dependency and will throw errors
const i18n = import('@/util/language');

function sortByName({ name: aName = '' }, { name: bName = '' }) {
  return aName.localeCompare(bName);
}

export default {
  state: () => ({
    userLocale: '',
    supportedLanguages: [],
    loadedLanguages: [],
  }),
  getters: {
    userLocale: (state) => {
      const { userLocale } = state;
      return state.supportedLanguages.find(({ code }) => code === userLocale);
    },
    supportedLanguages: state => state.supportedLanguages.sort(sortByName),
  },
  mutations: {
    setUserLocale(state, locale) {
      state.userLocale = locale;
    },
    setSupportedLanguages(state, languages) {
      state.supportedLanguages = languages || [];
    },
    addLoadedLanguage(state, language) {
      state.loadedLanguages.push(language);
    },
  },
  actions: {
    async setUserLocale({ state, commit, dispatch }, locale) {
      if (locale) {
        dispatch('fetchLanguage', locale);
        commit('setUserLocale', locale);

        return;
      }

      if (state.userLocale) {
        dispatch('fetchLanguage', state.userLocale);
        return;
      }

      const navigatorLanguages = [navigator.language, ...(navigator.languages || [])];
      const supportedLanguages = state.supportedLanguages?.map(({ code }) => code) || [];

      let language = 'en';

      const userDefaultLanguage = navigatorLanguages
        .find((code) => {
          if (supportedLanguages.includes(code)) {
            return true;
          }

          const { 'iso639-1': iso639v1 } = Locale.getByTag(code);

          return supportedLanguages.includes(iso639v1);
        });

      if (userDefaultLanguage) {
        if (supportedLanguages.includes(userDefaultLanguage)) {
          language = userDefaultLanguage;
        } else {
          language = Locale.getByTag(userDefaultLanguage)['iso639-1'];
        }
      }

      dispatch('fetchLanguage', language);
      commit('setUserLocale', language);
    },
  async fetchLanguages({ commit, dispatch }) {
    // فقط انگلیسی - بدون درخواست به سرور خارجی
    const supportedLanguages = [{
      code: 'en',
      name: 'English',
      countryCode: 'gb',
    }];

    commit('setSupportedLanguages', supportedLanguages);
    dispatch('setUserLocale');
  },

  async fetchLanguage(_, locale) {
    const VueI18n = (await i18n).default;
    // همیشه انگلیسی
    VueI18n.locale = 'en';
  },
    },
};
